import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--dropdown"
export default class extends Controller {
  static targets = ["menu", "button"];
  connect() {
    this.clickOutsideHandler = this._clickOutside.bind(this);
    document.addEventListener("click", this.clickOutsideHandler);
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler);
  }

  toggle(e) {
    e.preventDefault();
    this.menuTarget.classList.toggle("hidden");

    // hidden が外れたかどうかをチェック
    if (this.menuTarget.classList.contains("hidden")) {
      this.buttonTarget.classList.remove("active");
    } else {
      this.buttonTarget.classList.add("active");
    }
  }

  close() {
    this.menuTarget.classList.add("hidden");
    this.buttonTarget.classList.remove("active");
  }

  _clickOutside(event) {
    if (
      !this.buttonTarget.contains(event.target) &&
      !this.menuTarget.contains(event.target)
    ) {
      this.menuTarget.classList.add("hidden");
      this.buttonTarget.classList.remove("active"); // メニュー閉じたらactiveも外す
    }
  }
}
